import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';
import Headline from '../Headline';
import { LocaleContext } from '../../Banner';

const Header = ({ h1, h2, h3, promoCode, style }) => {
  const { dataJurisdiction } = useContext(LocaleContext);
  const headerRef = useRef(null);

  useEffect(() => {
    if (headerRef.current) {
      const headerHeight = headerRef.current.getBoundingClientRect().height;
      headerRef.current.setAttribute('data-header-height', headerHeight);
    }
  }, []);

  return (
    <header data-jurisdiction={dataJurisdiction} ref={headerRef} className={cn(styles.slideHeader)}>
      {h2 && (
        <Headline headlineLevel={2} headlineStyle={style.h2}>
          {h2}
        </Headline>
      )}
      {h1 && (
        <Headline headlineLevel={1} headlineStyle={style.h1}>
          {h1}
        </Headline>
      )}
      {h3 && (
        <Headline headlineLevel={3} headlineStyle={style.h3}>
          {h3}{' '}
          {promoCode && (
            <span data-jurisdiction={dataJurisdiction} className={cn(styles.headlinePromoCode)}>
              {promoCode}
            </span>
          )}
        </Headline>
      )}
    </header>
  );
};

Header.defaultProps = {
  h1: '',
  h2: '',
  h3: '',
  promoCode: '',
  style: {
    h1: {},
    h2: {},
    h3: {},
  },
};

Header.propTypes = {
  h1: PropTypes.string,
  h2: PropTypes.string,
  h3: PropTypes.string,
  promoCode: PropTypes.string,
  style: PropTypes.shape({
    h1: PropTypes.oneOfType([PropTypes.object]),
    h2: PropTypes.oneOfType([PropTypes.object]),
    h3: PropTypes.oneOfType([PropTypes.object]),
  }),
};

export default Header;
